
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { ClickEvent } from '@xt/client/types/home.d'

type SpecialZoneType = 'calligraphy' | 'prepareExhibition' | 'chinesePaint' | 'dayCourse' | 'coupon'

@Component({
  components: {}
})
export default class SpecialZone extends Vue {
  @Prop() dataSource: {
    calligraphy: { event?: ClickEvent }
    prepareExhibition: { event?: ClickEvent }
    chinesePaint: { event?: ClickEvent }
    dayCourse: { event?: ClickEvent }
    coupon: { event?: ClickEvent }
  }

  @Emit('handle-click')
  onShowQrcode(item) {
    return { item, type: 'view' }
  }

  // 点击事件
  handleClick(type: SpecialZoneType) {
    switch (type) {
      case 'calligraphy':
        this.onShowQrcode(this.dataSource.calligraphy)
        break
      case 'prepareExhibition':
        this.onShowQrcode(this.dataSource.prepareExhibition)
        break
      case 'chinesePaint':
        this.onShowQrcode(this.dataSource.chinesePaint)
        break
      case 'dayCourse':
        this.onShowQrcode(this.dataSource.dayCourse)
        break
      case 'coupon':
        this.onShowQrcode(this.dataSource.coupon)
        break
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
